import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface ChatModalButton {
  id: string;
  label: string;
  metadata?: string;
}

export interface ChatModalInstance {
  id: string;
  message: string;
  showCloseButton: boolean;
  buttons: ChatModalButton[];
}

export interface ChatModalButtonClick {
  modalId: string;
  buttonId: string;
  metadata?: string;
}

@Component({
  selector: 'app-chat-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './chat-modal.component.html',
  styleUrl: './chat-modal.component.css',
})
export class ChatInactivityModalComponent {
  @Input() modals: ChatModalInstance[] = [];

  @Output() buttonClick = new EventEmitter<ChatModalButtonClick>();

  onButtonClick(modalId: string, buttonId: string): void {
    const modal = this.modals.find((m) => m.id === modalId);
    const button = modal?.buttons.find((b) => b.id === buttonId);

    this.buttonClick.emit({
      modalId,
      buttonId,
      metadata: button?.metadata,
    });
  }

  trackByModalId(_: number, modal: ChatModalInstance): string {
    return modal.id;
  }
}
